"use client";

import React from 'react';
import { Globe, Building2, ShieldCheck, Zap, Award, LucideProps } from 'lucide-react';

const Marquee = () => {
  const partners = [
    { name: "Google News Initiative", icon: <Globe className="text-primary" /> },
    { name: "Meta Journalism Project", icon: <Building2 className="text-primary" /> },
    { name: "News Equity Fund", icon: <ShieldCheck className="text-primary" /> },
    { name: "SIP Labs", icon: <Zap className="text-primary" /> },
    { name: "Lenfest Local Lab", icon: <Award className="text-primary" /> },
  ];

  const displayPartners = [...partners, ...partners, ...partners];

  return (
    <section className="relative py-12 bg-white border-y border-gray-100 overflow-hidden">
      <div className="container mx-auto px-6 mb-8">
        <p className="text-center text-[10px] font-bold text-charcoal-muted uppercase tracking-[0.2em]">Instituciones que impulsan la innovación</p>
      </div>
      
      <div className="relative flex overflow-hidden">
        <div 
          className="flex whitespace-nowrap animate-marquee"
          style={{ animationDuration: '30s' }}
        >
          {displayPartners.map((partner, idx) => (
            <div key={idx} className="flex items-center gap-4 mx-12">
              <div className="w-10 h-10 bg-blue-50 rounded-xl flex items-center justify-center">
                {React.cloneElement(partner.icon as React.ReactElement<LucideProps>, { size: 20 })}
              </div>
              <span className="text-xl font-bold text-charcoal">
                {partner.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Marquee;